module.exports = __webpack_public_path__ + "img/jwgl-kbcx-lskb.d67471ed.png";